import {
	createActionsHook,
	createStateHook,
	createStore,
	type StoreActionApi,
} from 'react-sweet-state';

import type { RovoConfiguration } from '../shared-types/rovoConfigTypes.tsx';

export type RovoCurrentConfigState = {
	configuration: RovoConfiguration;
};

const noopConfiguration: RovoConfiguration = {
	getActions: async () => [],
};

const initialState: RovoCurrentConfigState = {
	configuration: noopConfiguration,
};

const actions = {
	setConfiguration:
		(configuration: RovoConfiguration) =>
		({ setState }: StoreActionApi<RovoCurrentConfigState>) => {
			setState({ configuration });
		},
	resetConfiguration:
		() =>
		({ setState }: StoreActionApi<RovoCurrentConfigState>) => {
			setState({ configuration: noopConfiguration });
		},
	updateConfiguration:
		(configuration: Partial<RovoConfiguration>) =>
		({ setState, getState }: StoreActionApi<RovoCurrentConfigState>) => {
			const state = getState();
			setState({ configuration: { ...state.configuration, ...configuration } });
		},
};

export const RovoCurrentConfigStore = createStore({
	initialState,
	actions,
	name: 'RovoCurrentConfigStore',
});

export const useRovoCurrentConfigStoreActions = createActionsHook(RovoCurrentConfigStore);

export const useRovoCurrentConfig = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration,
});

// Property-specific selectors for optimized re-renders
export const useRovoConfigGetActions = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.getActions,
});

export const useRovoConfigTags = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.tags,
});

export const useRovoConfigCustomGreeting = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.customGreeting,
});

export const useRovoConfigShouldShowGreeting = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.shouldShowGreeting,
});

export const useRovoConfigPrioritizeCustomActionResults = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.prioritizeCustomActionResults,
});

export const useRovoConfigNumStartersToShow = createStateHook(RovoCurrentConfigStore, {
	selector: (state: RovoCurrentConfigState) => state.configuration.numStartersToShow,
});
